import { END_POINTS } from "../constants/url";
import emptySplitApi from "../utils/rtk";

interface CommonResponseType {
  statusCode: number;
  message: string;
}

export interface DashboardMetricValue {
  status: string;
  value: number;
}

export interface DashboardSummaryResponse {
  totalUser: DashboardMetricValue;
  totalBookingVenue: DashboardMetricValue;
  totalBookingStorage: DashboardMetricValue;
  totalBooking: DashboardMetricValue;
  totalVenueListed: DashboardMetricValue;
  totalStorageListed: DashboardMetricValue;
  totalSubadmin: DashboardMetricValue;
}

export const dashboardApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getDashboard: builder.query<
      CommonResponseType & {
        data: DashboardSummaryResponse;
      },
      {
        from: number;
        size: number;
        search: string;
        country?:string
      }
    >({
      query: ({ from, size, search,country }) => ({
        url:
          `${END_POINTS.getdashboard}?from=${from}&size=${size}` +
          (search?.length ? `&search=${search}` : "") + (country?.length ? `&country=${country}` : ""),
        method: "GET",
      }),
    }),
     getUserGraph: builder.query<
      CommonResponseType & {
        data: Array<{ name: string; count: number }>;
      },
      {
        from: number;
        size: number;
        search: string;
        role:string;
        type:string
      }
    >({
      query: ({ from, size, search,role,type}) => ({
        url:
          `${END_POINTS.userGraph}?from=${from}&size=${size}&role=${role}&type=${type}` +
          (search?.length ? `&search=${search}` : ""),
        method: "GET",
      }),
    }),
     getVenueGraph: builder.query<
      CommonResponseType & {
        data: Array<{ name: string; count: number }>;
      },
      {
        from: number;
        size: number;
        search: string;
        categoryType:string;
         type:string
      }
    >({
      query: ({ from, size, search,categoryType,type}) => ({
        url:
          `${END_POINTS.venueGraph}?from=${from}&size=${size}&categoryType=${categoryType}&type=${type}` +
          (search?.length ? `&search=${search}` : ""),
        method: "GET",
      }),
    }),
     getBookingGraph: builder.query<
      CommonResponseType & {
        data: Array<{ name: string; count: number }>;
      },
      {
        from: number;
        size: number;
        search: string;
        categoryType:string;
         type:string
      }
    >({
      query: ({ from, size, search,categoryType,type}) => ({
        url:
          `${END_POINTS.bookingGraph}?from=${from}&size=${size}&categoryType=${categoryType}&type=${type}` +
          (search?.length ? `&search=${search}` : ""),
        method: "GET",
      }),
    }),
    
  
  }),
});

export const {
 useLazyGetDashboardQuery,
 useLazyGetBookingGraphQuery,
 useLazyGetUserGraphQuery,
 useLazyGetVenueGraphQuery
} = dashboardApi;
